const SK_MONTHS = [
  'Január',
  'Február',
  'Marec',
  'Apríl',
  'Máj',
  'Jún',
  'Júl',
  'August',
  'September',
  'Október',
  'November',
  'December',
]

export type ExportMonth = { year: number; month: number; label: string }

/** Every month from the code's creation up to the current month, newest first. */
export function buildMonths(createdAt: string): Array<ExportMonth> {
  const start = new Date(createdAt)
  const now = new Date()
  const months: Array<ExportMonth> = []

  let year = start.getFullYear()
  let month = start.getMonth() // 0-based

  while (
    year < now.getFullYear() ||
    (year === now.getFullYear() && month <= now.getMonth())
  ) {
    months.push({
      year,
      month: month + 1,
      label: `${SK_MONTHS[month]} ${year}`,
    })
    month += 1
    if (month > 11) {
      month = 0
      year += 1
    }
  }

  return months.reverse()
}

export function downloadBase64Pdf(base64: string, filename: string) {
  const bytes = atob(base64)
  const array = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) array[i] = bytes.charCodeAt(i)

  const url = URL.createObjectURL(
    new Blob([array], { type: 'application/pdf' })
  )
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
